import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FormStatusType } from '@/enums/form-status.enum'
import { ApplicationState } from '@/state/root.models'

import initialState from './initial-state'
import processDialogs from '../util'
import {
  SnackbarModel,
  DialogModel,
  DialogConfirmType,
  DrawerModel,
  PopoverConfirmType,
} from '../models'

const uiGlobalSlice = createSlice({
  name: 'ui-global',
  initialState,
  reducers: {
    setSnackbarAction(state, action: PayloadAction<SnackbarModel>) {
      state.snackbar = {
        ...state.snackbar,
        ...action.payload,
      }
    },
    setDialogAction(state, action: PayloadAction<DialogModel>) {
      state.dialog = { ...action.payload }
      state.dialogs = processDialogs(action.payload, state.dialogs)
    },
    setDialogConfirmAction(state, action: PayloadAction<DialogConfirmType>) {
      state.dialogConfirm = {
        ...state.dialogConfirm,
        ...action.payload,
      }
    },
    setFormModeAction(state, action: PayloadAction<FormStatusType>) {
      state.formMode = action.payload
    },
    setDrawerAction(state, action: PayloadAction<DrawerModel>) {
      state.drawer = { ...action.payload }
    },
    setLoadingFullAction(state, action: PayloadAction<boolean>) {
      state.isLoadingFull = action.payload
    },
    setSidebarStatusAction(state, action: PayloadAction<boolean>) {
      state.sidebarStatus = action.payload
    },
    setPopoverConfirmAction(state, action: PayloadAction<PopoverConfirmType>) {
      state.popoverConfirm = action.payload
    },
  },
})

export const {
  setSnackbarAction,
  setDialogAction,
  setDialogConfirmAction,
  setFormModeAction,
  setDrawerAction,
  setLoadingFullAction,
  setSidebarStatusAction,
  setPopoverConfirmAction,
} = uiGlobalSlice.actions

export const GlobalUIActions = uiGlobalSlice.actions

export const uiGlobalSelector = ({ globalUi }: ApplicationState) => globalUi

export default uiGlobalSlice
